import { render, staticRenderFns } from "./nested-file-sidebar.vue?vue&type=template&id=909dc2a0&"
import script from "./nested-file-sidebar.vue?vue&type=script&lang=js&"
export * from "./nested-file-sidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports